import { render } from "./OrderDiscardModal.vue?vue&type=template&id=63304298&ts=true"
import script from "./OrderDiscardModal.vue?vue&type=script&lang=ts"
export * from "./OrderDiscardModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__